function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import history from "instantsearch.js/es/lib/routers/history.js";
import { stripLocaleFromUrl } from "./utils/stripLocaleFromUrl.js";
export function createInstantSearchRouterNext(options) {
  var _ref = options || {},
    beforePopState = _ref.beforePopState,
    singletonRouter = _ref.singletonRouter,
    serverUrl = _ref.serverUrl,
    beforeStart = _ref.beforeStart,
    beforeDispose = _ref.beforeDispose,
    routerOptions = _ref.routerOptions;
  var handler;
  var ownBeforePopState = function ownBeforePopState() {
    return true;
  };

  // If we're rendering on the server, we create a simpler router
  if (typeof window === 'undefined') {
    return history(_objectSpread({
      getLocation: function getLocation() {
        return new URL(serverUrl);
      }
    }, routerOptions));
  }

  /**
   * Marker to skip `routeChangeComplete` event when the push comes from the router itself.
   */
  var lastPushFromThis = false;
  var router = history(_objectSpread({
    start: function start(onUpdate) {
      var _singletonRouter$rout;
      if (beforeStart) {
        beforeStart(onUpdate);
      }
      var initialPathname = singletonRouter.pathname;
      handler = function handler() {
        // Without this check, we would trigger an unnecessary search when navigating
        // to a page without InstantSearch
        if (singletonRouter.pathname === initialPathname && !lastPushFromThis) {
          onUpdate();
        }
        lastPushFromThis = false;
      };
      singletonRouter.events.on('routeChangeComplete', handler);
      if ((_singletonRouter$rout = singletonRouter.router) !== null && _singletonRouter$rout !== void 0 && _singletonRouter$rout._bps) {
        ownBeforePopState = singletonRouter.router._bps;
      }
      function libraryBeforePopState() {
        var previousPathname = singletonRouter.asPath.split('?')[0];
        var nextPathname = new URL(window.location.href).pathname;

        // We strip the locale from the pathname if it's present
        nextPathname = stripLocaleFromUrl(nextPathname, singletonRouter.locale, previousPathname !== '/');

        // We only want to trigger a server request when going back/forward to a different page
        return previousPathname !== nextPathname;
      }
      singletonRouter.beforePopState(function (state) {
        if (beforePopState) {
          return beforePopState({
            state: state,
            libraryBeforePopState: libraryBeforePopState,
            ownBeforePopState: ownBeforePopState
          });
        }
        return libraryBeforePopState();
      });
    },
    dispose: function dispose() {
      if (beforeDispose) {
        beforeDispose();
      }
      singletonRouter.events.off('routeChangeComplete', handler);
      singletonRouter.beforePopState(ownBeforePopState);
    },
    push: function push(newUrl) {
      // We need to do this because there's an error when using i18n on the
      // root path it says for example `pages/fr.js` doesn't exist
      var url = stripLocaleFromUrl(newUrl, singletonRouter.locale);

      // No need to provide the second argument, Next.js will know what to do
      singletonRouter.push(url, undefined, {
        shallow: true
      });
      lastPushFromThis = true;
    }
  }, routerOptions));
  router._isNextRouter = true;
  router.$$type = 'ais.nextjs';
  return router;
}